const COSMETIC_KEYS = ['color', 'logo', 'listeningText', 'theme'];
const PER_SESSION_KEYS = ['identity', 'name', 'metadata', 'jobMetadata', 'attrs'];
const RECOGNIZED_DATASET_KEYS = new Set([
    'lkAgent',
    ...COSMETIC_KEYS.map((k) => 'lk' + k.charAt(0).toUpperCase() + k.slice(1)),
    ...PER_SESSION_KEYS.map((k) => 'lk' + k.charAt(0).toUpperCase() + k.slice(1)),
]);
const VALID_THEMES = ['light', 'dark', 'system'];
export class MissingAgentAttributeError extends Error {
    constructor() {
        super('embed-popup: <script> tag is missing required `data-lk-agent` attribute');
        this.name = 'MissingAgentAttributeError';
    }
}
export function parseScriptDataset(dataset) {
    const agent = dataset.lkAgent;
    if (!agent) {
        throw new MissingAgentAttributeError();
    }
    for (const key of Object.keys(dataset)) {
        if (key.startsWith('lk') && !RECOGNIZED_DATASET_KEYS.has(key)) {
            // eslint-disable-next-line no-console
            console.warn(`embed-popup: ignoring unrecognized attribute \`data-${camelToKebab(key)}\` on snippet. Capability flags and agent name are server-controlled; cosmetic and per-session overrides must use one of the documented \`data-lk-*\` keys.`);
        }
    }
    const config = {
        agent,
        cosmetic: {},
        perSession: {},
    };
    if (dataset.lkColor !== undefined)
        config.cosmetic.color = dataset.lkColor;
    if (dataset.lkLogo !== undefined)
        config.cosmetic.logo = dataset.lkLogo;
    if (dataset.lkListeningText !== undefined)
        config.cosmetic.listeningText = dataset.lkListeningText;
    const theme = dataset.lkTheme;
    if (theme !== undefined) {
        if (theme === 'light' || theme === 'dark' || theme === 'system') {
            config.cosmetic.theme = theme;
        }
        else {
            // eslint-disable-next-line no-console
            console.warn(`embed-popup: ignoring \`data-lk-theme="${theme}"\` — expected one of ${VALID_THEMES.map((t) => `"${t}"`).join(', ')}.`);
        }
    }
    if (dataset.lkIdentity !== undefined)
        config.perSession.identity = dataset.lkIdentity;
    if (dataset.lkName !== undefined)
        config.perSession.name = dataset.lkName;
    if (dataset.lkMetadata !== undefined)
        config.perSession.metadata = dataset.lkMetadata;
    if (dataset.lkJobMetadata !== undefined) {
        const parsed = tryParseJSON(dataset.lkJobMetadata, 'data-lk-job-metadata');
        if (parsed !== undefined)
            config.perSession.jobMetadata = parsed;
    }
    if (dataset.lkAttrs !== undefined) {
        const parsed = tryParseJSON(dataset.lkAttrs, 'data-lk-attrs');
        if (parsed !== undefined)
            config.perSession.attrs = parsed;
    }
    return config;
}
function tryParseJSON(raw, attributeLabel) {
    try {
        return JSON.parse(raw);
    }
    catch (e) {
        const message = e instanceof Error ? e.message : String(e);
        // eslint-disable-next-line no-console
        console.warn(`embed-popup: ignoring \`${attributeLabel}\` — value is not valid JSON: ${message}`);
        return undefined;
    }
}
function camelToKebab(s) {
    return s.replace(/([A-Z])/g, '-$1').toLowerCase();
}
